import React, { createContext, PropsWithChildren, useContext } from 'react';

import { ProductData } from '../model';

export type FreeBundlesData = {
  readonly productData?: { [index: string]: ProductData };
};

export function useFreeBundlesData() {
  return useContext(FreeBundlesDataContext);
}

const FreeBundlesDataContext = createContext<FreeBundlesData>({
  productData: {}
});

export type FreeBundlesDataProviderProps = FreeBundlesData;

export function FreeBundlesDataProvider({
  productData,
  children
}: PropsWithChildren<FreeBundlesDataProviderProps>) {
  return (
    <FreeBundlesDataContext.Provider
      value={{
        productData
      }}
    >
      {children}
    </FreeBundlesDataContext.Provider>
  );
}
